import { styled } from 'goober';
import { forwardRef } from 'react';

export const IconContainter = styled('div')`
    position: absolute;
    top: -2px;
`;

export const DropdownInput = styled('input', forwardRef)`
    border: 0;
    clip: rect(0 0 0 0);
    overflow: hidden;
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    right: 0px;
`;

export const Label = styled('span')`
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    cursor: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 10;
    color: ${(props) => props.theme.colors.ui.dark};
    user-select: none;
`;

export const Container = styled('div', forwardRef)<{ $justify?: string; $gap?: number; disabled?: boolean }>`
    gap: ${(props) => (props.$gap ? `${props.$gap}px` : 'initial')};
    display: flex;
    height: 16px;
    align-items: center;
    position: relative;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(p) => (p.disabled ? 0.5 : 1)};
    overflow: hidden;
    justify-content: ${(props) => (props.$justify ? props.$justify : 'initial')};

    color: ${(props) => props.theme.colors.ui.dark};
    fill: ${(props) => props.theme.colors.ui.dark};

    &:hover {
        color: ${(props) => props.theme.colors.neutral.w700};
        fill: ${(props) => props.theme.colors.neutral.w700};
    }

    &:has(input:disabled) {
        color: ${(props) => props.theme.colors.neutral.w300};
        fill: ${(props) => props.theme.colors.neutral.w300};
        cursor: not-allowed;
    }

    &:has(input:checked) {
        color: ${(props) => props.theme.colors.primary.w500};
        fill: ${(props) => props.theme.colors.primary.w500};
    }

    &:hover > ${IconContainter}, &:has(input:checked) > ${IconContainter} {
        visibility: visible;
    }

    &:has(input:focus-visible) {
        border-color: ${(props) => props.theme.colors.ui.dark};
    }

    & > ${IconContainter} {
        overflow: hidden;
        position: relative;
        color: inherit;
        cursor: inherit;
        padding: 0px;
        margin: 0px;
    }

    & > ${IconContainter} > svg {
        position: relative;
        top: 2px;
        margin-left: -2px;
    }
`;

export const MenuContainer = styled('div', forwardRef)`
    position: absolute;
    z-index: 1041;
`;

export const DropdownWrap = styled('div')(({ theme }) => ({
    height: '24px',
    border: '1px solid',
    padding: '4px 10px',
    borderColor: theme.colors.neutral.w100,
    '&:hover': {
        borderColor: theme.colors.neutral.w200,
    },
    borderRadius: '8px',
}));
